import { Icon } from 'antd';
import * as React from 'react';
const LocationPinIconSvg = (props) => {
  return (
    <svg width="12px" height="16px" viewBox="0 0 12 16" version="1.1"
    // xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    >
    <g id="Inquiry" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="FF-inq--Booking-2.2"
        transform="translate(-625.000000, -325.000000)" fill={props.color ? props.color : "#666666"} fillRule="nonzero">
            <g id="noun_Location_1041848" transform="translate(625.000000, 325.000000)">
                <path
                // tslint:disable-next-line: max-line-length
                d="M10.6504615,2.32615385 C9.52061538,0.841846154 7.79261538,0 5.93169231,0 C4.07076923,0 2.34276923,0.841846154 1.21292308,2.32615385 C-0.404307692,4.45292308 -0.404307692,7.39938462 1.21292308,9.52615385 L5.93169231,15.6849231 L10.6504615,9.52615385 C12.2676923,7.39938462 12.2676923,4.45292308 10.6504615,2.32615385 Z M5.93169231,2.68061538 C7.63753846,2.68061538 9.03323077,4.07630769 9.03323077,5.78215385 C9.03323077,7.488 7.63753846,8.88369231 5.93169231,8.88369231 C4.22584615,8.88369231 2.83015385,7.488 2.83015385,5.78215385 C2.83015385,4.07630769 4.22584615,2.68061538 5.93169231,2.68061538 Z" id="Shape"></path>
            </g>
        </g>
    </g>
</svg>

  );
};

const LocationPinIcon = props => (
  <Icon component={(innerProps) => {
    return LocationPinIconSvg(Object.assign({}, innerProps, props));
  }}></Icon>
);
export default LocationPinIcon;
